import React, { Fragment, useState } from 'react';
import Popover from '@material-ui/core/Popover';
import { Calendar } from 'react-datepicker2';
import moment from 'moment-jalaali';
import { Chip, makeStyles, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles({
  root: {
    borderRadius: 4,
    border: '1px solid #ccc',
    padding: '10px',
    display: 'flex',
    gap: 10,
    flexFlow: 'row wrap',
    minHeight: 54,
    alignItems: 'center',
  },
  placeholder: {
    color: 'gray',
  },
});

const MultipyDatePicker = ({ value, onChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  function handleDelete(i) {
    onChange(value.filter((_, j) => j !== i));
  }
  function handleChange(selectedDate) {
    const _values = value.map((v) => moment(v).jDayOfYear());
    if (_values?.includes(moment(selectedDate).jDayOfYear())) return;
    onChange([...value, moment(selectedDate)]);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  function handleOpen(e) {
    setAnchorEl(e.currentTarget);
  }

  return (
    <Fragment>
      <div
        className={classes.root}
        onClick={handleOpen}
        style={{ cursor: 'pointer' }}
      >
        {value?.length === 0 && (
          <label className={classes.placeholder}>یک تاریخ انتخاب کنید</label>
        )}
        {value?.map((d, i) => (
          <Chip
            key={i}
            label={d.format('jYYYY/jMM/jDD')}
            deleteIcon={<CancelIcon />}
            onDelete={() => handleDelete(i)}
          />
        ))}
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Calendar
          isGregorian={false}
          calendarClass="calendarStyles"
          onChange={handleChange}
          onSelect={handleClose}
        />
      </Popover>
    </Fragment>
  );
};

export default React.memo(MultipyDatePicker);
